module.exports = __webpack_public_path__ + "img/kefus.ff578845.png";